<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Delete Event
      </h2>
    </template>
    <template #modal-body>
      <div class="Notice Notice--warning DeleteForm">
        <h3 class="Notice-header">
          Please read carefully
        </h3>
        <p>You are going to delete the event named:</p>
        <ul>
          <li><b>{{ event.name }} </b></li>
        </ul>
        <p>Once deleted this event cannot be recovered and students that were added by this event will be deleted as well.</p>
        <p>Are you sure you want to delete this event?</p>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          :class="[{'is-loading': ui.submitLoading }, 'Button Button--danger']"
          @click="handleDeleteEvent"
        >
          Delete Event
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import { mapActions } from 'vuex';
import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
  props: {
    event: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      ui: {
        submitLoading: false,
      },
    };
  },
  methods: {
    ...mapActions('events', {
      deleteEvent: 'deleteEvent',
    }),
    handleDeleteEvent() {
      this.ui.submitLoading = true;
      this.deleteEvent(this.event.id)
        .then(({ data }) => {
          // success
          this.isOpen = false;
          this.$emit('delete-event:success');
          this.$bus.$emit('displayMsg', {
            text: data.message,
            type: 'success',
          });
          this.ui.submitLoading = false;
        })
        .catch(({ data }) => {
          this.ui.submitLoading = false;
          this.$bus.$emit('global-dismiss-modal'); // Dismiss modal
          this.$bus.$emit('displayMsg', {
            text: data.message,
            type: 'warning',
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>

.DeleteForm {

  h3 {
    text-align: center;
  }

  p, ul, li {
    color: #a94442;
  }

  ul {
    list-style: disc;
    margin-left: 15px;
  }
}

.BorderedHeaderModal {
  h3, p {
    color: #A94442
  }
  .Notice {
    margin-bottom: 0;
  }
}
</style>
